
import { defineComponent } from "vue";
import Dropdown2 from "@/components/dropdown/Dropdown2.vue";

export default defineComponent({
  name: "kt-widget-12",
  components: {
    Dropdown2,
  },
  props: {
    widgetClasses: String,
  },
  setup() {
    const list = [
      {
        agent: {
          image: "/media/svg/avatars/001-boy.svg",
          name: "Rachel Clarence",
          skills: "56767676",
        },
        amount: {
          value: "$30.00",
          remarks: "2023/01/12",
        },
        order: {
          value: "77F42422AV",
          remarks: "Completed",
        },
        merchant: {
          name: "www.adveroffer.com",
          fields: "Moisturizng Feet Cream",
        },
        campaign: {
          name: "Nutraceuticals",
          fields: "Continuity",
        },
        rating: {
          value: 0,
          remarks: "",
        },
        status: {
          label: "Refund Request",
          color: "danger",
        },
      },
      {
        agent: {
          image: "/media/svg/avatars/001-boy.svg",
          name: "Chester Simmons",
          skills: "23232323232",
        },
        amount: {
          value: "$80.00",
          remarks: "2023/01/22",
        },
        order: {
          value: "34342422AV",
          remarks: "Completed",
        },
        merchant: {
          name: "www.adveroffer.com",
          fields: "Daily face Cream",
        },
        campaign: {
          name: "Dietary Supps",
          fields: "Straight Sale",
        },

        rating: {
          value: 3,
          remarks: "Average",
        },
        status: {
          label: "Cancel Request",
          color: "warning",
        },
      },
    ];

    return {
      list,
    };
  },
});
